var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1395_7577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 5,
    height: 3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03979 16.5217H10.8919V18.4916H6.03979V16.5217Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1395_7577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44445 17.6292C7.77331 17.6292 7.16875 17.2231 6.89805 16.5926L6.12631 16.9381C6.53065 17.8799 7.43944 18.4915 8.44445 18.4915C9.46453 18.4915 10.3772 17.8724 10.7738 16.9113L9.99863 16.5732C9.73182 17.2151 9.12337 17.6292 8.44445 17.6292Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1395_7577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.8889V16.5217H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1395_7577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.723 15.2171L14.4972 13.3177C14.401 13.2343 14.3456 13.1166 14.3456 12.9875V7.77634C14.3456 6.10877 13.6963 4.55539 12.5168 3.40413C11.8233 2.72797 11.0001 2.2494 10.1098 1.9838C10.1282 1.85075 10.1355 1.7177 10.1248 1.57721C10.0616 0.840483 9.53096 0.213968 8.83406 0.0541119C8.32232 -0.0635459 7.79551 0.0580833 7.39117 0.38822C6.99072 0.718854 6.76085 1.20885 6.76085 1.73707C6.76085 1.82444 6.77543 1.90387 6.78661 1.98727C4.32365 2.73939 2.54349 5.11737 2.54349 7.9357V12.9836C2.54349 13.1126 2.48809 13.2343 2.39138 13.3142L0.166059 15.2131C0.0698347 15.2965 0.0139465 15.4181 0.0139465 15.5437V15.9766C0.0139465 16.2159 0.202994 16.4095 0.436752 16.4095H16.4518C16.6856 16.4095 16.8746 16.2159 16.8746 15.9766V15.5437C16.8712 15.4181 16.8154 15.2965 16.723 15.2171ZM7.59869 1.73707C7.59869 1.47097 7.71386 1.22771 7.91409 1.06091C8.1182 0.893603 8.37383 0.833037 8.64452 0.893603C8.98228 0.973531 9.24909 1.28877 9.28262 1.64969C9.28651 1.69884 9.27922 1.74799 9.27533 1.79763C8.90793 1.74451 8.53712 1.72565 8.15514 1.74054C7.96949 1.74799 7.78433 1.76735 7.60257 1.79763C7.60646 1.7748 7.59869 1.75593 7.59869 1.73707ZM1.09332 15.5472L2.92936 13.9784C3.21852 13.7317 3.3857 13.3708 3.3857 12.9836V7.9357C3.3857 5.07567 5.49973 2.73194 8.19985 2.60287C9.60142 2.53436 10.9257 3.04322 11.9346 4.02717C12.9435 5.01461 13.5 6.34409 13.5 7.77634V12.9836C13.5 13.3673 13.6667 13.7317 13.9558 13.9784L15.7919 15.5472H1.09332Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.937852c6315801a0fef6bfb21c4162e5.svg";
export { ForwardRef as ReactComponent };